module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_30.acedef32.jpg";